import * as React from "react";
import { createRoot } from "react-dom/client";

// internationalization
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n"; // initialized i18next instance
// project imports
import App from "./App";

// style + assets
import "./assets/scss/style.scss";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <I18nextProvider i18n={i18n}>
    <App />
  </I18nextProvider>
);
